import { Component } from '@angular/core';
import { BeesFooterComponent } from "../bees-footer/bees-footer.component";
import { BeesHeaderComponent } from "../bees-header/bees-header.component";

@Component({
  selector: 'app-page-gallery',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './page-gallery.component.html',
  styleUrl: './page-gallery.component.scss'
})
export class PageGalleryComponent {

}
